'use strict'

import React, { useEffect, useState } from 'react'
import { SketchPicker } from 'react-color'
import { Color } from '../helpers';

type Props = Readonly<{
    color: Color;
    onChange: (e) => void;
  }>;

export const ColorPicker = ({ color, onChange }: Props) => {
    const [pickerVisible, setPickerVisible] = useState(false);

    
    return (
      <div>
        <div className="color-swatch" onClick={e => setPickerVisible(!pickerVisible)}>
          <div style={{
            height:"100%",
            width:"100%",
            background:`rgba(${color.red},${color.green},${color.blue},${color.alpha})`
        }} />
        </div>
        { pickerVisible ? <div style={{
            position: 'absolute',
            zIndex: 3000
        }}>
          {/*intercepts clicks anywhere to close the picker*/}
          <div style={ 
            {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
                cursor:'default'
            } 
          } 
          onClick={ e => setPickerVisible(false) }/>
          <SketchPicker 
            presetColors={[]}
            color={ 
                {
                    r: color.red,
                    g: color.green,
                    b: color.blue,
                    a: color.alpha
                } 
            } 
            onChange={(e) => {
                onChange(e);
          }} />
        </div> : null }

      </div>
    )
}

export default ColorPicker
